import { SIZE_FULL } from '@/lib/gridElements/size';

import { ChoroplethMapChart } from '@/components/composite/Charts/ChoroplethMapChart';

export const followersCountriesConfig = {
    title: 'chart.linkedin.followers_countries',
    height: 300,
    name: {
        name: 'chart.linkedin.followers_countries_country',
        value: 'chart.linkedin.followers_countries_value',
        country: 'chart.linkedin.followers_countries_country',
        percentage: 'percentage'
    },
    defaultTableSorting: [{ id: 'value', desc: true }],
    tooltip: 'chart.linkedin.followers_countries_tooltip',
    noLegend: true,
    datePickerDoesNotApply: true,
    id: 'followers_countries',
    size: SIZE_FULL,
    type: 'chart',
    element: ChoroplethMapChart
};
